import { Injectable, APP_INITIALIZER } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { User } from 'src/app/models/user';
import { appState } from '@services/app-state';
import { AuthService } from '@noammazuz/vzn-feathers';
import { Router } from '@angular/router';
import init from '@feathersjs/authentication-client/lib';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  sideMenuIsOpen: Subject<boolean> = new Subject();
  user$: BehaviorSubject<User> = new BehaviorSubject(null);
  appState = appState;

  constructor(
    private authService: AuthService<User>,
    private router: Router
  ) {
    this.sideMenuIsOpen.subscribe( res => {
      window.dispatchEvent(new Event('resize'));
    });

    this.init();
  }

  async init() {
    if (await this.authService.isAuth()) {
      this.authSuccess();
    }
  }

  async authSuccess() {
    this.appState.user = new User(await this.authService.getAuthUser());
  }

  logout() {
    this.authService.logout();
    delete this.appState.user;
    this.sideMenuIsOpen.next(false);
    this.user$.next(null);
  }
}
